<template>
  <div class="cv-tile-standard">
    <slot></slot>
  </div>
</template>

<script setup></script>
